import React from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import FilterSelect from './filter-select';

export default function CandidateFilters({
  filters,
  setFilters,
  selectedFilters,
  setSelectedFilters,
}) {
  return (
    <Stack direction="row" alignItems="center" spacing="12px" mb="12px">
      <FilterSelect
        key="SKILLS"
        group="SKILLS"
        selectedFilters={selectedFilters}
        filters={filters.SKILLS}
        setFilters={setFilters}
        setSelectedFilters={setSelectedFilters}
      />

      <FilterSelect
        key="DOMAINS"
        group="DOMAINS"
        selectedFilters={selectedFilters}
        setFilters={setFilters}
        filters={filters.DOMAINS}
        setSelectedFilters={setSelectedFilters}
      />

      <FilterSelect
        key="TAGS"
        group="TAGS"
        selectedFilters={selectedFilters}
        setFilters={setFilters}
        filters={filters.TAGS}
        setSelectedFilters={setSelectedFilters}
      />
      <FilterSelect
        key="CANDIDATE_SOURCE"
        group="CANDIDATE_SOURCE"
        selectedFilters={selectedFilters}
        setFilters={setFilters}
        filters={filters.CANDIDATE_SOURCE}
        setSelectedFilters={setSelectedFilters}
      />
    </Stack>
  );
}

CandidateFilters.propTypes = {
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  selectedFilters: PropTypes.array,
  setSelectedFilters: PropTypes.func,
};
